<template>
    <main class="m-mvp">
        <y-container>
            <y-mvp-hero
                class="m-mvp__hero"
                @hero-content="getHeroContent"
            />
        </y-container>
        <div class="m-mvp__features">
            <y-container>
                <y-mvp-features />
            </y-container>
        </div>
        <y-container>
            <y-mvp-streaming class="m-mvp__streaming" />
        </y-container>
        <div class="m-mvp__benefits-slider">
            <y-container>
                <y-benefit-slider />
            </y-container>
        </div>
        <y-container>
            <y-case-study class="m-mvp__case-study " />
        </y-container>

        <div class="m-mvp__tech-stack">
            <y-container>
                <y-tech-stack />
            </y-container>
        </div>
        <y-container>
            <y-mvp-types class="m-mvp__mvp-types" />
        </y-container>
        <div class="m-mvp__get-in-touch">
            <y-container>
                <y-get-in-touch />
            </y-container>
        </div>
        <y-container>
            <y-faq class="m-mvp__faq" />
        </y-container>
    </main>
</template>

<script >
    import PageMixin from '@groot-nodes/mixins/Page.js';
    import YMvpHero from '@modules/mvp/components/Hero/Hero.vue';
    import YMvpFeatures from '@modules/mvp/components/Features/Features.vue';
    import YMvpStreaming from '@modules/mvp/components/Streaming/Streaming.vue';
    import YCaseStudy from '@modules/mvp/components/CaseStudy/CaseStudy.vue';
    import YTechStack from '@modules/mvp/components/TechStack/TechStack.vue';
    import YGetInTouch from '@modules/mvp/components/GetInTouch/GetInTouch.vue';
    import YFaq from '@modules/mvp/components/Faq/Faq.vue';
    import YMvpTypes from '@modules/mvp/components/MvpTypes/MvpTypes.vue';
    import YBenefitSlider from '@modules/mvp/components/BenefitsSlider/BenefitsSlider.vue';

    // Helper
    import { removeSymbol } from '@/helpers/helpers';

    export default {
        name      : 'BlogListPage',
        components: {
            YMvpHero,
            YMvpFeatures,
            YMvpStreaming,
            YCaseStudy,
            YTechStack,
            YGetInTouch,
            YFaq,
            YMvpTypes,
            YBenefitSlider,
        },
        mixins: [PageMixin],

        /**
         * @inheritdoc
         */
        data() {
            return {
                heroContent: '',
            };
        },

        /**
         *
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.heroContent.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.heroContent.seo_meta_description,
                    },
                ],
            };
        },

        methods: {
            removeSymbol,

            /**
             * get Hero content
             *
             * @param {object} value
             */
            getHeroContent(value) {
                this.heroContent = value;
            },
        },
    };

</script>

<style lang="scss" src="@/modules/mvp/scss/mvp.scss"/>
